export const formatDateForKotlin = function (date) {
  if (!date) return null;
  return {
    day: date.getDate(),
    month: date.getMonth() + 1,
    year: date.getFullYear(),
    hours: date.getHours(),
    minutes: date.getMinutes(),
    seconds: date.getSeconds(),
  };
};

export const formatDateStringSvkForKotlin = function (dateStringSVK) {
  const dateArray = dateStringSVK.split('.');
  const date = new Date(`${dateArray[2]}/${dateArray[1]}/${dateArray[0]}`);
  return formatDateForKotlin(date);
};

export const makeDateFromKotlin = function (date, addTime = false) {
  const { year, month, day, hours, minutes } = date;
  if (!addTime) return new Date(`${year}/${month}/${day}`);
  return new Date(`${year}/${month}/${day}-${hours}:${minutes}`);
};

export const makeDateFromNativeInput = function (dateString) {
  const year = parseInt(dateString.split('-')[0], 10);
  if (year < 1000) return null;
  return new Date(dateString);
};

export const makeDateForNativeInput = function (date) {
  let month = date.getMonth() + 1;
  month = month < 10 ? `0${month}` : month;
  let day = date.getDate();
  day = day < 10 ? `0${day}` : day;
  return `${date.getFullYear()}-${month}-${day}`;
};

export const getMonthByWord = function (month, wordCase) {
  if (wordCase === 'genitive') {
    if (month === 1) return 'januára';
    if (month === 2) return 'februára';
    if (month === 3) return 'marca';
    if (month === 4) return 'apríla';
    if (month === 5) return 'mája';
    if (month === 6) return 'júna';
    if (month === 7) return 'júla';
    if (month === 8) return 'augusta';
    if (month === 9) return 'septembra';
    if (month === 10) return 'októbra';
    if (month === 11) return 'novembra';
    return 'decembra';
  }

  if (month === 1) return 'január';
  if (month === 2) return 'február';
  if (month === 3) return 'marec';
  if (month === 4) return 'apríl';
  if (month === 5) return 'máj';
  if (month === 6) return 'jún';
  if (month === 7) return 'júl';
  if (month === 8) return 'august';
  if (month === 9) return 'september';
  if (month === 10) return 'október';
  if (month === 11) return 'november';
  return 'december';
};

export const makeDateStringFromKotlin = function (kotlinDate, monthByWord = false, wordCase = 'nominative') {
  const date = makeDateFromKotlin(kotlinDate);
  let month = "";
  if (monthByWord) month = getMonthByWord(date.getMonth() + 1, wordCase);
  else month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  const day = kotlinDate.day < 10 ? `0${kotlinDate.day}` : kotlinDate.day;
  if (monthByWord) return `${day}. ${month} ${date.getFullYear()}`;
  return `${day}.${month}.${date.getFullYear()}`;
};

export const treatAsUTC = function (date) {
  const result = new Date(date);
  result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
  return result;
};

export const daysBetween = function (startDate, endDate) {
  const millisecondsPerDay = 24 * 60 * 60 * 1000;
  return (treatAsUTC(endDate) - treatAsUTC(startDate)) / millisecondsPerDay;
};

export const addYears = function (date, year) {
  return new Date(date.setFullYear(date.getFullYear() + year));
};
